
var base = require('base/product/base');
var gtm = require('googletagmanager/tagManager');

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}


/**
 * Ensure exactly one focusable radio in a radiogroup (roving tabindex pattern)
 * @param {jQuery} $group - container with role radiogroup
 */
function ensureRovingTabindex($group) {
    if (!$group || !$group.length) return;
    var $radios = $group.find('[role="radio"]');
    if (!$radios.length) return;
    $radios.attr('tabindex', '-1');
    var $selected = $radios.filter('[aria-checked="true"]');
    var $enabled = $radios.filter('[aria-disabled!="true"]');
    var $target = $selected.first();
    if (!$target.length) {
        $target = $enabled.first().length ? $enabled.first() : $radios.first();
    }
    $target.attr('tabindex', '0');
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    $productContainer.find('.shade-name-pxp').empty().html(attr.displayValue ? attr.displayValue : '');
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="'
            + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $swatchButton.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $swatchButton.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        if (!attrValue.selectable) {
            $swatchButton.addClass('unselectable');
        } else {
            $swatchButton.removeClass('unselectable');
        }

        // Accessibility state sync
        $swatchButton.attr('role', 'radio');
        $swatchButton.attr('aria-checked', attrValue.selected ? 'true' : 'false');
        $swatchButton.attr('aria-disabled', attrValue.selectable ? 'false' : 'true');
        $swatchButton.attr('tabindex', attrValue.selected ? '0' : '-1');
    });

    // Ensure radiogroup has a single focusable control
    var $group = $productContainer.find('[data-attr="' + attr.id + '"]');
    ensureRovingTabindex($group);
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['shadeRGBCode'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var $carousel = $productContainer.find('.carousel');
    $carousel.carousel('dispose');
    var carouselId = $carousel.attr('id');
    $carousel.empty().append(
        '<ol class="carousel-indicators"></ol>' +
        '<div class="carousel-inner" role="listbox"></div>' +
        '<a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-slide="prev">' +
            '<svg class="icon-left icon--md" aria-hidden="true" aria-label="Previous Slide Icon">' +
                '<use xlink:href="' + window.STATIC_URL + '/images/compiled/sprites.svg#mk-icons-caret-left-black"></use>' +
            '</svg>' +
            '<span class="sr-only">' + $carousel.data('prev') + '</span>' +
        '</a>' +
        '<a class="carousel-control-next" href="#' + carouselId + '" role="button" data-slide="next">' +
            '<svg class="icon-right icon--md" aria-hidden="true" aria-label="Next Slide Icon">' +
                '<use xlink:href="' + window.STATIC_URL + '/images/compiled/sprites.svg#mk-icons-caret-right-black"></use>' +
            '</svg>' +
            '<span class="sr-only">' + $carousel.data('next') + '</span>' +
        '</a>'
    );
    for (var i = 0; i < imgs.length; i++) {
        $('<div class="carousel-item"><img src="' + imgs[i].url + '" class="d-block img-fluid mk-aspect-ratio-1" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>')
            .appendTo($carousel.find('.carousel-inner'));
        $('<li data-target="#' + carouselId + '" data-slide-to="' + i + '" class="border-0 mk-rounded-2 dot-indicator"></li>')
            .appendTo($carousel.find('.carousel-indicators'));
    }
    $carousel.find('.carousel-item').first().addClass('active');
    $carousel.find('.carousel-indicators > li').first().addClass('active');
    if (imgs.length === 1) {
        $carousel.find('.carousel-indicators, a[class^="carousel-control-"]').detach();
    }
    $carousel.carousel();
    $carousel.find('.carousel-indicators').attr('aria-hidden', true);
}


/**
 * Update product images
 * @param {Object[]} imgs - Array of hi-res product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
/**
 * Updates product images in the container based on available images
 * @param {Object[]} imgs - Array of image objects with url and alt properties
 * @param {jQuery} $productContainer - DOM element containing product images
 */
function updateProductImages(imgs, $productContainer) {
    const IMAGE_SELECTOR = '.js-pxp-image';
    const $imagesContainer = $productContainer.find('.pxp-images .hi-res-images-container');
    let $images = $imagesContainer.find(IMAGE_SELECTOR);

    const displayedImagesCount = $images.length;
    const maxImagesToDisplay = Math.min(imgs.length, 7);

    /**
     * Updates an existing image element with new image data
     * @param {jQuery} $imgElement - jQuery image element to update
     * @param {Object} img - Image object with url and alt properties
     */
    function updateExistingImage($imgElement, img) {
        $imgElement.attr('src', img.url);
        $imgElement.attr('alt', img.alt);
    }

    /**
     * Creates a new image element with image data
     * @param {jQuery} $existingImageElement - jQuery image element to create
     * @param {Object} imageData - Image object with url and alt properties
     * @returns {jQuery} - New image element
     */
    function createNewImage($existingImageElement, imageData) {
        let $newImage;

        if ($existingImageElement !== null) {
            $newImage = $existingImageElement.clone();
        } else {
            $newImage = $('<img>');
            $newImage.addClass('img-fluid w-100 product-detail__pxp-image js-pxp-image');
        }

        $newImage.attr('src', imageData.url);
        $newImage.attr('alt', imageData.alt);

        return $newImage;
    }

    /**
     * Creates a container div for a hi-res image with appropriate column class.
     * @param {boolean} [isFirstImage=false] - Whether this is the first image (affects column width)
     * @returns {jQuery} - New jQuery div element with correct classes
     */
    function createImageContainer(isFirstImage = false) {
        // Defensive: ensure isFirstImage is boolean
        const isFirst = Boolean(isFirstImage);
        // Use semantic class names and avoid string interpolation injection
        const colClass = isFirst ? 'col-12' : 'col-6';
        // Only allow known classes, never inject untrusted data
        const $newImageContainer = $('<div>')
            .addClass('hi-res-image')
            .addClass('mk-image-skeleton')
            .addClass(colClass);

        return $newImageContainer;
    }

    /**
     * Adds a new image element to the container
     * @param {Object} imageData - Image object with url and alt properties
     * @param {jQuery} $existingImageElement - jQuery image element to add, if null, a new image element will be created
     */
    function addNewImage(imageData, $existingImageElement = null) {
        const $newImage = createNewImage($existingImageElement, imageData);
        const $newImageContainer = createImageContainer($existingImageElement == null);

        // Append the new image to the container
        $newImageContainer.append($newImage);

        // Append the new image container to the images parent container
        $imagesContainer.append($newImageContainer);
    }

    try {
        const totalImagesToHandle = Math.min(Math.max(displayedImagesCount, maxImagesToDisplay), 7);

        if (totalImagesToHandle === 0) {
            $imagesContainer.empty();
        }
        else {
            // Single loop to handle both adding/updating and removing images efficiently
            for (let i = 0; i < totalImagesToHandle; i++) {
                const $currentImage = $images.eq(i);
                const imgData = imgs[i];

                if (imgData && $currentImage.length) {
                    updateExistingImage($currentImage, imgData);
                } else if (imgData && !$currentImage.length) {
                    if (i === 0) {
                        $imagesContainer.empty();
                        addNewImage(imgData, null);
                    } else {
                        $images = $imagesContainer.find(IMAGE_SELECTOR);
                        const $lastImage = $images.eq(i - 1);
                        addNewImage(imgData, $lastImage);
                    }
                } else if ($currentImage.length) {
                    $currentImage.parent().remove();
                }
            }
        }
    }
    catch (e) {
        // Do nothing at moment
    }
}

/**
 * Update certficate Badge
 *
 * @param {response} response - Ajax response
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateCertificateBadge(response, $productContainer) {
    var $pxpImages = $productContainer.find('.pxp-images');
    $pxpImages.find('.product-badge-js').empty();
    if (response && response.product && response.product.certficateBadgeTemplate) {
        if ($pxpImages.find('.hi-res-image').length > 0) {
            $pxpImages.find('.product-badge-js').html(response.product.certficateBadgeTemplate);
        }
    }
}

/**
 * Update wishlist Button on PDP
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 */
function updateWishlist($productContainer, response) {
    const $wishlistTile = $productContainer.find('.wishlistTile');
    const $wishlisticon = $productContainer.find('.wishlist-icon');
    const $wishlistFilledIcon = $productContainer.find('.wishlist-filled-icon');
    if (response.product.custom.isInWishlist) {
        $wishlistTile.addClass('active');
        $wishlisticon.addClass('d-none');
        $wishlistFilledIcon.removeClass('d-none');
    } else {
        $wishlistTile.removeClass('active');
        $wishlisticon.removeClass('d-none');
        $wishlistFilledIcon.addClass('d-none');
    }
}

/**
 * Update MirrorMe Source
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 */
function updateMirrorMeSource($productContainer, response) {
    const enterpriseMarketingPartID = response && response.product && response.product.custom && response.product.custom.enterpriseMarketingPartID ? response.product.custom.enterpriseMarketingPartID : '';
    const isDeepLink = response && response.product && response.product.custom && response.product.custom.isDeepLink ? response.product.custom.isDeepLink : false;
    if (isDeepLink && enterpriseMarketingPartID) {
        const mirrorMeBaseURL = $('.mirror-me-Iframes').attr('data-baseurl');
        const consultant = $('.mirror-me-Iframes').attr('data-consultant');
        const mksubsidiaryid = $('.mirror-me-Iframes').attr('data-mksubsidiaryid');
        const iframeAppProject = $('.mirror-me-Iframes').attr('data-iframeappproject');
        const iframeAppDomain = $('.mirror-me-Iframes').attr('data-iframeappdomain');
        const language = $('.mirror-me-Iframes').attr('data-language');
        const newSrc =
            mirrorMeBaseURL +
            '?project=' + iframeAppProject + 
            '&lang=' + language + 
            '&deeplink=' + enterpriseMarketingPartID + 
            '&d=' + iframeAppDomain + 
            '&m=' + consultant + 
            '&MKSubsidiaryID=' + mksubsidiaryid;

        // Update the iframe src
        $productContainer.find('#MirrorMe').attr('src', newSrc);
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
            $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').data('pid', response.product.id);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    try {
        if (!$productContainer.hasClass('product-quickview')) {
            updateProductImages(primaryImageUrls, $productContainer);
            updateCertificateBadge(response, $productContainer);
            $productContainer.find('.product').attr('data-pid', response.product.id);
            updateWishlist($productContainer, response);
            updateMirrorMeSource($productContainer, response);
        } else {
            createCarousel(primaryImageUrls, $productContainer);
        }
    }
    catch (e) {
        // Do nothing at moment
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer, resources: response.resources
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
    // Update prices inside Sticky Add to Bag Section (mobile view shows price within button)
    try {
        const $stickyAtb = $('.sticky-atb');
        const price = response?.product?.price.html;
        const $priceElement = $('.price', $stickyAtb);
        $priceElement.replaceWith(price);
    } catch (err) {
        // Handle error
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}


/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }
}

/**
 * @param {string} finishValue - raw product finish value
 * @returns {string} formatted product finish value
 */
function formatProductFinish(finishValue) {
    if (!finishValue) {
        return '';
    }
    return `<span class='productFinishLabel' aria-label="Product Finish: ${finishValue}">${finishValue}</span>`;
}

/**
 * Updates the product finish value in the product detail page
 * @param {Object} product - product object from ajax response
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateProductFinish(product, $productContainer) {
    if (product.custom && product.custom.productFinish) {
        $productContainer.find('.product-detail__productFinish').html(formatProductFinish(product.custom.productFinish));
    } else {
        $productContainer.find('.product-detail__productFinish').empty();
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
base.attributeSelect = function (selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );
        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                updateProductFinish(data.product, $productContainer);
                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer }
                );
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

base.colorAttribute = function () {

    // Click to select
    $(document).off('click', '[data-attr="shadeRGBCode"] button:not(".selected"):not("[disabled]")').on('click', '[data-attr="shadeRGBCode"] button:not(".selected"):not("[disabled]")', function (e) {
        e.preventDefault();

        if ($(this).attr('disabled')) {
            return;
        }
        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }

        base.attributeSelect($(this).attr('data-url'), $productContainer);
    });

    // Keyboard navigation (roving tabindex)
    $(document).on(
        'keydown',
        '[data-attr="shadeRGBCode"] [role="radio"]',
        function (e) {
            var keys = {
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                HOME: 36,
                END: 35,
                ENTER: 13,
                SPACE: 32
            };
            var code = e.which || e.keyCode;
            if (
                [
                    keys.LEFT,
                    keys.UP,
                    keys.RIGHT,
                    keys.DOWN,
                    keys.HOME,
                    keys.END,
                    keys.ENTER,
                    keys.SPACE
                ].indexOf(code) === -1
            ) {
                return;
            }
            e.preventDefault();

            var $current = $(this);
            const $group = $current.closest('[data-attr="shadeRGBCode"]');
            const $radios = $group.find('[role="radio"]');
            const $enabled = $radios.filter(
                ':not(:disabled)[aria-disabled!="true"]'
            );

            // Index within enabled list (fallback to first enabled)
            let idxEnabled = $enabled.index($current);
            if (idxEnabled === -1) {
                idxEnabled = $enabled.index(
                    $enabled.filter('[aria-checked="true"]').first()
                );
                if (idxEnabled === -1) idxEnabled = 0;
            }

            /**
             * Moves focus to the given radio element and updates tabindex.
             * @param {jQuery} $t - The target radio element.
             * @returns {undefined}
             */
            function moveTo($t) {
                if (!$t || !$t.length) return undefined;
                $radios.attr('tabindex', '-1');
                $t.attr('tabindex', '0').focus();
                return undefined;
            }

            if (code === keys.HOME) {
                moveTo($enabled.first());
                return;
            }
            if (code === keys.END) {
                moveTo($enabled.last());
                return;
            }
            if (code === keys.LEFT || code === keys.UP)
                moveTo($enabled.eq(Math.max(idxEnabled - 1, 0)));
            if (code === keys.RIGHT || code === keys.DOWN)
                moveTo(
                    $enabled.eq(Math.min(idxEnabled + 1, $enabled.length - 1))
                );
            if (
                (code === keys.ENTER || code === keys.SPACE) &&
                !$current.attr('disabled')
            )
                $current.click();

            if (
                (code === keys.ENTER || code === keys.SPACE) &&
                !$current.attr('disabled')
            ) {
                $current.click();
            }
        }
    );
};

base.selectAttribute = function () {
    $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }
        base.attributeSelect(e.currentTarget.value, $productContainer);
    });
};

base.addToCart = function () {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find('.product-id').text(),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = base.getPidValue($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }
        var $productTile = document.querySelector(`.product[data-pid="${pid}"] .product-tile`);
        var productListName = $productTile && $productTile.dataset ? $productTile.dataset.gtmProductListName : '';
        var productDetailObject = window.dataLayer.find(
            item => item.event === "productDetailView"
        );
        if (productDetailObject) {
            productListName = productDetailObject && productDetailObject.ecommerce && productDetailObject.ecommerce.detail && productDetailObject.ecommerce.detail.products ? productDetailObject.ecommerce.detail.products[0].item_list_name : '';  
        }

        addToCartUrl = getAddToCartUrl();

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: base.getQuantitySelected($(this)),
            productListName: productListName
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    if (data.gateError && data.error) {
                        // If gate error, redirect to gate closed URL
                        window.location = data.redirectUrl;
                        return;
                    }
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    if (data.productData) {
                        gtm.addToCart(data.productData, data.productData.quantity);
                    }
                    if (data.quantityTotal === 1) {
                        gtm.openCart();
                    }
                    $.spinner().stop();
                    miniCartReportingUrl(data.reportingURL);
                    const miniCart = require('../components/miniCart');
                    miniCart.miniCartShow();
                    var trayOpened = false;
                    $('body').on('trayModalOpened', function (e, traydata) {
                        if (!trayOpened && data.maxQty && data.maxQty.error && traydata.customClassName.includes('mini-cart-tray')) {
                            $('.minicart-maxqty-error').addClass('alert alert-danger p-4');
                            var errorHtml = '<strong class="title mb-1 font-weight-xbold small d-block">' + data.maxQty.message + '</strong>'
                                + '<p class="m-0 small mk-text-color-black">' + data.maxQty.msg + '</p>';
                            $('.minicart-maxqty-error').append(errorHtml);
                            trayOpened = true;
                        }
                    });
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

module.exports = base;